import React from "react";

export default function About() {
	return (
		<div className="container" style={{ minHeight: "75.6vh" }}>
			<h3>About Page</h3>
			<p>
				Lorem ipsum dolor sit amet consectetur adipisicing elit. Iusto
				nihil saepe velit magni animi at in itaque deleniti. Molestiae
				quibusdam, nobis consequuntur consectetur et ad consequatur
				repudiandae vero inventore dolorum delectus porro commodi,
				pariatur ratione quisquam voluptatibus placeat! Tempore
				voluptatem numquam repudiandae ad amet, recusandae accusantium
				delectus sit placeat officiis unde ullam beatae ab neque fugiat
				magni voluptate mollitia id eum odit. Soluta non animi laborum
				praesentium omnis molestias cum dolores corporis temporibus
				quidem tempora, assumenda, eius dolorum illum asperiores
				expedita ipsa nihil voluptates quam? Accusamus, ducimus corrupti
				explicabo tempora placeat voluptas quod hic repellat accusantium
				unde, a nostrum maxime!
			</p>
		</div>
	);
}
